import { Link } from "react-router-dom";
import { Card } from "../components/Card.js";

type Tile = {
  to: string;
  title: string;
  description: string;
};

const TILES: ReadonlyArray<Tile> = [
  {
    to: "/settings/schedule",
    title: "Schedule — who is where, week by week",
    description: "Shifts by provider and location, plus time-off blocks.",
  },
  {
    to: "/settings/calendar",
    title: "Booking rules — slot length and lead times",
    description: "Practice timezone, slot granularity, and lead-time limits.",
  },
  {
    to: "/settings/locations",
    title: "Locations",
    description: "Offices, capacity, and the virtual visit option.",
  },
  {
    to: "/settings/providers",
    title: "Providers",
    description:
      "Providers — who sees patients, where they're licensed, and their Google connection.",
  },
  {
    to: "/settings/audit",
    title: "Audit log",
    description:
      "Every admin action — who viewed which appointment, who cancelled, who edited config.",
  },
  {
    to: "/settings/account",
    title: "Account",
    description:
      "Your signed-in identity, roles, and tenant. Sign out from any device.",
  },
  {
    to: "/settings/health",
    title: "Health",
    description:
      "API connectivity and Google Calendar connection status at a glance.",
  },
  {
    to: "/settings/troubleshoot",
    title: "Calendar troubleshooting",
    description:
      "Sync health, mirrored busy blocks, computed availability, and a live drift check against Google.",
  },
  {
    to: "/settings/test-email",
    title: "Test email",
    description:
      "Send a sample notification email to verify Azure Communication Services delivery.",
  },
];

export function SettingsHubPage() {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      {TILES.map((tile) => (
        <Link
          key={tile.to}
          to={tile.to}
          className="group block focus:outline-none"
        >
          <Card>
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-sm font-semibold text-slate-900 group-hover:text-blue-600">
                  {tile.title}
                </h2>
                <p className="mt-1 text-sm text-slate-600">{tile.description}</p>
              </div>
              <span
                aria-hidden="true"
                className="mt-1 text-slate-400 group-hover:text-blue-600"
              >
                →
              </span>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
}
